// utility function
// If you use the moveToFront() method, make sure you are specifying the second argument to the data() join method, or your data will be out of synch with your DOM. http://stackoverflow.com/a/15817561

export default d3.selection.prototype.moveToFront = function() {
    return this.each(function() {
        this.parentNode.appendChild(this);
    });
};